// 'use client';

// import {
//   Box,
//   Flex,
//   Table,
//   Tbody,
//   Td,
//   Text,
//   Th,
//   Thead,
//   Tr,
//   useColorModeValue,
//   Button,
//   Input,
//   FormControl,
//   FormLabel,
//   useToast,
//   IconButton,
//   Modal,
//   ModalOverlay,
//   ModalContent,
//   ModalHeader,
//   ModalFooter,
//   ModalBody,
//   ModalCloseButton,
//   useDisclosure,
//   InputGroup,
//   InputLeftElement,
//   Select,
//   Badge,
//   Image,
//   Switch,
// } from '@chakra-ui/react';
// import { MdEdit, MdDelete, MdSearch } from 'react-icons/md';
// import React, { useState, useEffect, useMemo } from 'react';
// import axios from 'axios';
// import Card from 'components/card/Card';
// import ReactQuill from 'react-quill-new';
// import 'react-quill-new/dist/quill.snow.css';

// export default function ChapterManagement() {
//   const [courses, setCourses] = useState([]); // ✅ ADD

//   const [subjects, setSubjects] = useState([]);
//   const [subSubjects, setSubSubjects] = useState([]);

//   const [chapters, setChapters] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [loading, setLoading] = useState(false);

//   // Image State
//   const [chapterImage, setChapterImage] = useState(null);
//   const [loadingSubjects, setLoadingSubjects] = useState(false);

//   // Form State (Backend-aligned)
//   const [formData, setFormData] = useState({
//     courseId: '',
//     subjectId: '',
//     subSubjectId: '',
//     name: '',
//     description: '',
//     weightage: 0,
//     isFreePreview: false,
//   });

//   const [editData, setEditData] = useState(null);
//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const textColor = useColorModeValue('secondaryGray.900', 'white');
//   const toast = useToast();

//   const modules = useMemo(
//     () => ({
//       toolbar: [
//         [{ header: [1, 2, false] }],
//         ['bold', 'italic', 'underline', 'strike'],
//         [{ list: 'ordered' }, { list: 'bullet' }],
//         ['link', 'image'],
//         ['clean'],
//       ],
//     }),
//     [],
//   );

//   const formats = [
//     'header',
//     'bold',
//     'italic',
//     'underline',
//     'strike',
//     'list',
//     'bullet',
//     'link',
//     'image',
//   ];

//   const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/');
//   const token = localStorage.getItem('token');
//   const headers = { Authorization: `Bearer ${token}` };

//   // 🔹 Fetch Subjects + Chapters
//   const fetchData = async () => {
//     try {
//       setLoading(true);

//       const [courseRes, subjectRes, chapterRes] = await Promise.all([
//         axios.get(`${baseUrl}api/admin/courses`, { headers }),
//         axios.get(`${baseUrl}api/admin/subjects`, { headers }),
//         axios.get(`${baseUrl}api/admin/chapters`, { headers }),
//       ]);

//       setCourses(courseRes.data.data || []);
//       setSubjects(subjectRes.data.data || []);
//       setChapters(chapterRes.data.data || []);
//     } catch (err) {
//       if (err.response?.status === 401) {
//         localStorage.removeItem('token');
//         window.location.href = '/auth/sign-in';
//       }

//       toast({
//         title: err.response?.data?.message || 'Data load failed',
//         status: 'error',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };
//   useEffect(() => {
//     if (!token) {
//       window.location.href = '/auth/sign-in';
//       return;
//     }

//     fetchData();
//   }, [token]);

//   const handleCourseChange = async (courseId) => {
//     // 🔥 FULL RESET WHEN COURSE CHANGES
//     setFormData({
//       courseId,
//       subjectId: '',
//       subSubjectId: '',
//       name: '',
//       description: '',
//       weightage: 0,
//       isFreePreview: false,
//     });

//     setSubjects([]);
//     setSubSubjects([]);

//     if (!courseId) return;

//     setLoadingSubjects(true);

//     try {
//       const res = await axios.get(
//         `${baseUrl}api/admin/subjects?courseId=${courseId}`,
//         { headers },
//       );

//       setSubjects(res.data.data || []);
//     } catch (err) {
//       toast({ title: 'Subject load error', status: 'error' });
//     } finally {
//       setLoadingSubjects(false);
//     }
//   };

//   // 🔹 Load Sub-Subjects when Subject changes
//   // const handleSubjectChange = async (subjectId) => {
//   //   setFormData({
//   //     ...formData,
//   //     subjectId,
//   //     subSubjectId: '',
//   //   });

//   //   setSubSubjects([]);

//   //   if (!subjectId) return;

//   //   try {
//   //     const res = await axios.get(
//   //       `${baseUrl}api/admin/sub-subjects?subjectId=${subjectId}`,
//   //       { headers },
//   //     );
//   //     setSubSubjects(res.data.data || []);
//   //   } catch (err) {
//   //     toast({ title: 'Sub-Subject load error', status: 'error' });
//   //   }
//   // };
//   const handleSubjectChange = async (subjectId) => {
//     setFormData((prev) => ({
//       ...prev,
//       subjectId,
//       subSubjectId: '',
//     }));

//     setSubSubjects([]);

//     if (!subjectId) return;

//     try {
//       const res = await axios.get(
//         `${baseUrl}api/admin/sub-subjects?subjectId=${subjectId}`,
//         { headers },
//       );

//       setSubSubjects(res.data.data || []);
//     } catch (err) {
//       toast({ title: 'Sub-Subject load error', status: 'error' });
//     }
//   };
//   // 🔹 Load Topics when Sub-Subject changes
//   const handleSubSubjectChange = (ssId) => {
//     setFormData({
//       ...formData,
//       subSubjectId: ssId,
//     });
//   };

//   // 🔹 CREATE CHAPTER
//   const handleCreate = async () => {
//     // 🔹 VALIDATION
//     if (!formData.courseId || !formData.subjectId || !formData.subSubjectId) {
//       return toast({
//         title: 'Course, Subject and Sub-Subject required',
//         status: 'warning',
//       });
//     }

//     if (!formData.name || formData.name.trim().length < 3) {
//       return toast({
//         title: 'Chapter name must be at least 3 characters',
//         status: 'warning',
//       });
//     }

//     if (loading) return; // 🔥 Prevent double submit

//     setLoading(true);

//     try {
//       const payload = new FormData();

//       Object.entries(formData).forEach(([key, value]) => {
//         if (value !== '' && value !== null && value !== undefined) {
//           payload.append(key, value);
//         }
//       });

//       if (chapterImage) {
//         payload.append('image', chapterImage);
//       }

//       await axios.post(`${baseUrl}api/admin/chapters`, payload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'multipart/form-data',
//         },
//       });

//       toast({ title: 'Chapter Created!', status: 'success' });

//       // 🔥 COMPLETE CLEAN RESET
//       setFormData({
//         courseId: '',
//         subjectId: '',
//         subSubjectId: '',
//         name: '',
//         description: '',
//         weightage: 0,
//         isFreePreview: false,
//       });

//       setSubjects([]);
//       setSubSubjects([]);
//       setChapterImage(null);

//       await fetchData();
//     } catch (err) {
//       toast({
//         title: err.response?.data?.message || 'Create failed',
//         status: 'error',
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // 🔹 UPDATE CHAPTER
//   const handleUpdate = async () => {
//     try {
//       const payload = new FormData();

//       payload.append(
//         'subSubjectId',
//         editData.subSubjectId?._id || editData.subSubjectId,
//       );

//       payload.append('name', editData.name);
//       payload.append('description', editData.description || '');
//       payload.append('weightage', editData.weightage);
//       payload.append('isFreePreview', editData.isFreePreview);

//       if (editData.newImage) {
//         payload.append('image', editData.newImage);
//       }

//       await axios.patch(
//         `${baseUrl}api/admin/chapters/${editData._id}`,
//         payload,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'multipart/form-data',
//           },
//         },
//       );

//       toast({ title: 'Updated Successfully', status: 'success' });
//       onClose();
//       fetchData();
//     } catch (err) {
//       toast({
//         title: err.response?.data?.message || 'Something went wrong',
//         status: 'error',
//       });
//     }
//   };

//   // 🔹 DELETE CHAPTER
//   const handleDelete = async (id) => {
//     if (window.confirm('Are you sure?')) {
//       try {
//         await axios.delete(`${baseUrl}api/admin/chapters/${id}`, { headers });
//         toast({ title: 'Deleted', status: 'info' });
//         fetchData();
//       } catch (err) {
//         toast({ title: 'Delete failed', status: 'error' });
//       }
//     }
//   };

//   // 🔹 SEARCH FILTER
//   // const filteredData = chapters.filter(
//   //   (c) =>
//   //     c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//   //     c.subSubjectId?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
//   // );
//   const filteredData = chapters
//     .filter(
//       (c) =>
//         c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         c.subSubjectId?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
//     )
//     .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt)); // 🔥 old → new
//   return (
//     <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
//       {/* ADD CHAPTER CARD */}
//       <Card mb="20px" p="20px">
//         <Text color={textColor} fontSize="22px" fontWeight="700" mb="20px">
//           Add New Chapter
//         </Text>

//         <Flex gap="15px" wrap="wrap">
//           {/* COURSE ✅ */}
//           <FormControl width={{ base: '100%', md: '20%' }}>
//             <FormLabel fontSize="sm" fontWeight="700">
//               Course
//             </FormLabel>
//             <Select
//               placeholder="Select Course"
//               value={formData.courseId}
//               onChange={(e) => handleCourseChange(e.target.value)}
//             >
//               {courses.map((c) => (
//                 <option key={c._id} value={c._id}>
//                   {c.name}
//                 </option>
//               ))}
//             </Select>
//           </FormControl>

//           {/* SUBJECT */}
//           {/* <FormControl width={{ base: '100%', md: '20%' }}>
//             <FormLabel fontSize="sm" fontWeight="700">
//               Subject
//             </FormLabel>
//             <Select
//               placeholder="Select Subject"
//               value={formData.subjectId}
//               onChange={(e) => handleSubjectChange(e.target.value)}
//               isDisabled={!formData.courseId}
//             >
//               {subjects.map((s) => (
//                 <option key={s._id} value={s._id}>
//                   {s.name}
//                 </option>
//               ))}
//             </Select>
//           </FormControl> */}
//           {/* SUBJECT DROPDOWN */}
//           <FormControl width={{ base: '100%', md: '20%' }}>
//             <FormLabel fontSize="sm" fontWeight="700">
//               Subject
//             </FormLabel>
//             <Select
//               placeholder={loadingSubjects ? 'Loading...' : 'Select Subject'}
//               value={formData.subjectId}
//               onChange={(e) => handleSubjectChange(e.target.value)}
//               isDisabled={!formData.courseId || loadingSubjects} // Jab load ho raha ho tab bhi disabled rahe
//             >
//               {subjects.map((s) => (
//                 <option key={s._id} value={s._id}>
//                   {s.name}
//                 </option>
//               ))}
//             </Select>
//           </FormControl>

//           {/* SUB-SUBJECT */}
//           <FormControl width={{ base: '100%', md: '20%' }}>
//             <FormLabel fontSize="sm" fontWeight="700">
//               Sub-Subject
//             </FormLabel>
//             <Select
//               placeholder="Select Sub-Subject"
//               value={formData.subSubjectId}
//               onChange={(e) => handleSubSubjectChange(e.target.value)}
//               isDisabled={!formData.subjectId}
//             >
//               {subSubjects.map((s) => (
//                 <option key={s._id} value={s._id}>
//                   {s.name}
//                 </option>
//               ))}
//             </Select>
//           </FormControl>

//           {/* NAME */}
//           <FormControl width={{ base: '100%', md: '20%' }}>
//             <FormLabel fontSize="sm" fontWeight="700">
//               Chapter Name
//             </FormLabel>
//             <Input
//               value={formData.name}
//               onChange={(e) =>
//                 setFormData({
//                   ...formData,
//                   name: e.target.value,
//                 })
//               }
//               placeholder="Ex: Genetics"
//             />
//           </FormControl>

//           {/* DESCRIPTION ✅ */}
//           <FormControl width="100%">
//             <FormLabel fontSize="sm" fontWeight="700">
//               Description
//             </FormLabel>

//             <ReactQuill
//               // key={formData.courseId + formData.subjectId + formData.name}
//               // theme="snow"
//               // value={formData.description}
//               // onChange={(value) =>
//               //   setFormData({
//               //     ...formData,
//               //     description: value,
//               //   })
//               // }
//               // style={{ background: 'white' }}
//               theme="snow"
//               value={formData.description}
//               onChange={(value) =>
//                 setFormData({ ...formData, description: value })
//               }
//               modules={modules} // Ye add kiya
//               formats={formats} // Ye add kiya
//               style={{ background: 'white', minHeight: '150px' }}
//             />
//           </FormControl>

//           {/* IMAGE */}
//           <FormControl width={{ base: '100%', md: '20%' }}>
//             <FormLabel fontSize="sm" fontWeight="700">
//               Chapter Image
//             </FormLabel>
//             <Input
//               type="file"
//               accept="image/*"
//               onChange={(e) => {
//                 const file = e.target.files[0];

//                 if (!file) return;

//                 if (!file.type.startsWith('image/')) {
//                   toast({
//                     title: 'Only image files allowed',
//                     status: 'warning',
//                   });
//                   return;
//                 }

//                 if (file.size > 2 * 1024 * 1024) {
//                   toast({
//                     title: 'Image must be less than 2MB',
//                     status: 'warning',
//                   });
//                   return;
//                 }

//                 setChapterImage(file);
//               }}
//               pt="1"
//             />
//           </FormControl>

//           <Button
//             colorScheme="brand"
//             mt="30px"
//             onClick={handleCreate}
//             isLoading={loading}
//           >
//             Save
//           </Button>
//         </Flex>
//       </Card>

//       {/* LIST TABLE */}
//       <Card p="20px">
//         <Flex justify="space-between" mb="20px">
//           <Text color={textColor} fontSize="18px" fontWeight="700">
//             Chapters
//           </Text>

//           <InputGroup maxW="300px">
//             <InputLeftElement children={<MdSearch />} />
//             <Input
//               placeholder="Search..."
//               value={searchTerm}
//               onChange={(e) => setSearchTerm(e.target.value)}
//             />
//           </InputGroup>
//         </Flex>

//         <Box overflowX="auto">
//           <Table variant="simple">
//             <Thead bg={useColorModeValue('gray.50', 'navy.800')}>
//               <Tr>
//                 <Th>Image</Th>
//                 <Th>Name</Th>

//                 <Th>Sub-Subject</Th>
//                 <Th>Actions</Th>
//               </Tr>
//             </Thead>

//             <Tbody>
//               {filteredData.map((item) => (
//                 <Tr key={item._id}>
//                   <Td>
//                     <Image
//                       src={
//                         item.image
//                           ? item.image.startsWith('http')
//                             ? item.image
//                             : `${baseUrl.replace(/\/$/, '')}${item.image}`
//                           : 'https://via.placeholder.com/50'
//                       }
//                       w="40px"
//                       h="40px"
//                       borderRadius="8px"
//                       objectFit="cover"
//                       fallbackSrc="https://via.placeholder.com/40"
//                     />
//                   </Td>

//                   <Td fontWeight="700">{item.name}</Td>

//                   <Td>
//                     <Badge colorScheme="purple">
//                       {item.subSubjectId?.name || 'N/A'}
//                     </Badge>
//                   </Td>

//                   <Td>
//                     <IconButton
//                       icon={<MdEdit />}
//                       onClick={async () => {
//                         setEditData(item);

//                         // Subject set karo (important)
//                         const subjectId = item.subSubjectId?.subjectId?._id;

//                         if (subjectId) {
//                           try {
//                             const res = await axios.get(
//                               `${baseUrl}api/admin/sub-subjects?subjectId=${subjectId}`,
//                               { headers },
//                             );
//                             setSubSubjects(res.data.data || []);
//                           } catch (err) {
//                             toast({
//                               title: 'Failed to load sub-subjects',
//                               status: 'error',
//                             });
//                           }
//                         }

//                         onOpen();
//                       }}
//                       mr="2"
//                     />
//                     <IconButton
//                       icon={<MdDelete />}
//                       colorScheme="red"
//                       onClick={() => handleDelete(item._id)}
//                     />
//                   </Td>
//                 </Tr>
//               ))}
//             </Tbody>
//           </Table>
//         </Box>
//       </Card>

//       {/* EDIT MODAL */}
//       <Modal isOpen={isOpen} onClose={onClose}>
//         <ModalOverlay />
//         <ModalContent pb="4">
//           <ModalHeader>Edit Chapter</ModalHeader>
//           <ModalCloseButton />
//           <ModalBody>
//             {editData && (
//               <Flex direction="column" gap="4">
//                 <FormControl>
//                   <FormLabel>Subject</FormLabel>
//                   <Select
//                     value={editData.subSubjectId?.subjectId?._id || ''}
//                     onChange={async (e) => {
//                       const subjectId = e.target.value;

//                       setEditData({
//                         ...editData,
//                         subSubjectId: '',
//                       });

//                       try {
//                         const res = await axios.get(
//                           `${baseUrl}api/admin/sub-subjects?subjectId=${subjectId}`,
//                           { headers },
//                         );
//                         setSubSubjects(res.data.data || []);
//                       } catch (err) {
//                         toast({
//                           title: 'Failed to load sub-subjects',
//                           status: 'error',
//                         });
//                       }
//                     }}
//                   >
//                     {subjects.map((s) => (
//                       <option key={s._id} value={s._id}>
//                         {s.name}
//                       </option>
//                     ))}
//                   </Select>
//                 </FormControl>

//                 <FormControl>
//                   <FormLabel>Sub-Subject</FormLabel>
//                   <Select
//                     value={editData.subSubjectId?._id || editData.subSubjectId}
//                     onChange={(e) =>
//                       setEditData({
//                         ...editData,
//                         subSubjectId: e.target.value,
//                       })
//                     }
//                   >
//                     {subSubjects.map((ss) => (
//                       <option key={ss._id} value={ss._id}>
//                         {ss.name}
//                       </option>
//                     ))}
//                   </Select>
//                 </FormControl>
//                 <FormControl>
//                   <FormLabel>Chapter Name</FormLabel>
//                   <Input
//                     value={editData.name}
//                     onChange={(e) =>
//                       setEditData({
//                         ...editData,
//                         name: e.target.value,
//                       })
//                     }
//                   />
//                 </FormControl>
//                 <FormControl>
//                   <FormLabel>Description</FormLabel>
//                   <ReactQuill
//                     theme="snow"
//                     value={editData.description}
//                     onChange={(val) =>
//                       setEditData({ ...editData, description: val })
//                     }
//                     modules={modules}
//                     formats={formats}
//                     style={{ background: 'white' }}
//                   />
//                 </FormControl>

//                 <FormControl>
//                   <FormLabel>Update Image</FormLabel>
//                   <Input
//                     type="file"
//                     accept="image/*"
//                     onChange={(e) =>
//                       setEditData({
//                         ...editData,
//                         newImage: e.target.files[0],
//                       })
//                     }
//                     pt="1"
//                   />
//                 </FormControl>

//                 {/* <FormControl>
//                   <FormLabel>Free Preview</FormLabel>
//                   <Switch
//                     isChecked={editData.isFreePreview}
//                     onChange={(e) =>
//                       setEditData({
//                         ...editData,
//                         isFreePreview: e.target.checked,
//                       })
//                     }
//                   />
//                 </FormControl> */}
//               </Flex>
//             )}
//           </ModalBody>

//           <ModalFooter>
//             <Button colorScheme="brand" onClick={handleUpdate}>
//               Update
//             </Button>
//           </ModalFooter>
//         </ModalContent>
//       </Modal>
//     </Box>
//   );
// }

'use client';

import {
  Box,
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  Input,
  FormControl,
  FormLabel,
  useToast,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  InputGroup,
  InputLeftElement,
  Select,
  Badge,
  Image,
  Switch,
  Icon, // ✅ NEW
} from '@chakra-ui/react';
import { MdEdit, MdDelete, MdSearch, MdDragIndicator } from 'react-icons/md'; // ✅ MdDragIndicator added
import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from 'axios';
import Card from 'components/card/Card';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

export default function ChapterManagement() {
  const [courses, setCourses] = useState([]);

  const [subjects, setSubjects] = useState([]);
  const [subSubjects, setSubSubjects] = useState([]);

  const [chapters, setChapters] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);

  // Image State
  const [chapterImage, setChapterImage] = useState(null);
  const [loadingSubjects, setLoadingSubjects] = useState(false);

  // Filter states
  const [filterSubjectId, setFilterSubjectId] = useState('');
  const [filterSubSubjects, setFilterSubSubjects] = useState([]);
  const [filterSubSubjectId, setFilterSubSubjectId] = useState('');

  // ✅ Drag-and-drop states
  const [orderedList, setOrderedList] = useState([]);
  const [orderChanged, setOrderChanged] = useState(false);
  const [savingOrder, setSavingOrder] = useState(false);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const dragItem = useRef(null);
  const hasDragged = useRef(false);
  const dragOverBg = useColorModeValue('blue.50', 'navy.700');

  // Form State (Backend-aligned)
  const [formData, setFormData] = useState({
    courseId: '',
    subjectId: '',
    subSubjectId: '',
    name: '',
    description: '',
    weightage: 0,
    isFreePreview: false,
  });

  const [editData, setEditData] = useState(null);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const toast = useToast();

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link', 'image'],
        ['clean'],
      ],
    }),
    [],
  );

  const formats = [
    'header',
    'bold',
    'italic',
    'underline',
    'strike',
    'list',
    'bullet',
    'link',
    'image',
  ];

  const baseUrl = (process.env.REACT_APP_BASE_URL || '').replace(/\/?$/, '/');
  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  // 🔹 Fetch Courses + Subjects + Chapters
  const fetchData = async () => {
    try {
      setLoading(true);

      const [courseRes, subjectRes, chapterRes] = await Promise.all([
        axios.get(`${baseUrl}api/admin/courses`, { headers }),
        axios.get(`${baseUrl}api/admin/subjects`, { headers }),
        axios.get(`${baseUrl}api/admin/chapters`, { headers }),
      ]);

      setCourses(courseRes.data.data || []);
      setSubjects(subjectRes.data.data || []);
      setChapters(chapterRes.data.data || []);
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem('token');
        window.location.href = '/auth/sign-in';
      }

      toast({
        title: err.response?.data?.message || 'Data load failed',
        status: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      window.location.href = '/auth/sign-in';
      return;
    }
    fetchData();
  }, [token]);

  // ✅ Refresh pe pehla subject auto-select karo (sub-subject ki tarah)
useEffect(() => {
  if (subjects.length > 0 && !filterSubjectId) {
    const firstSubjectId = subjects[0]._id;
    setFilterSubjectId(firstSubjectId);

    // Pehle subject ke sub-subjects bhi load karo
    axios
      .get(`${baseUrl}api/admin/sub-subjects?subjectId=${firstSubjectId}`, {
        headers,
      })
      .then((res) => {
        setFilterSubSubjects(res.data.data || []);
      })
      .catch(() => {});
  }
}, [subjects]);

  // ✅ Sync orderedList whenever chapters/filters/search change, reset unsaved drag state
useEffect(() => {
  // ✅ Jab tak koi filter select na ho, table empty rakho
  if (!filterSubjectId && !filterSubSubjectId) {
    setOrderedList([]);
    setOrderChanged(false);
    return;
  }

  const synced = chapters
    .filter((c) =>
      filterSubSubjectId
        ? (c.subSubjectId?._id || c.subSubjectId)?.toString() ===
          filterSubSubjectId
        : filterSubjectId
          ? c.subSubjectId?.subjectId?._id?.toString() === filterSubjectId ||
            c.subSubjectId?.subjectId?.toString() === filterSubjectId
          : false, // ✅ Fallback false — koi bhi nahi dikhega
    )
    .filter(
      (c) =>
        c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.subSubjectId?.name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase()),
    )
    .sort((a, b) => (a.order || 0) - (b.order || 0));

  setOrderedList(synced);
  setOrderChanged(false);
}, [chapters, filterSubjectId, filterSubSubjectId, searchTerm]);

  // 🔹 Course change — full reset
  const handleCourseChange = async (courseId) => {
    setFormData({
      courseId,
      subjectId: '',
      subSubjectId: '',
      name: '',
      description: '',
      weightage: 0,
      isFreePreview: false,
    });

    setSubjects([]);
    setSubSubjects([]);

    if (!courseId) return;

    setLoadingSubjects(true);

    try {
      const res = await axios.get(
        `${baseUrl}api/admin/subjects?courseId=${courseId}`,
        { headers },
      );
      setSubjects(res.data.data || []);
    } catch (err) {
      toast({ title: 'Subject load error', status: 'error' });
    } finally {
      setLoadingSubjects(false);
    }
  };

  // 🔹 Subject change — load sub-subjects
  const handleSubjectChange = async (subjectId) => {
    setFormData((prev) => ({
      ...prev,
      subjectId,
      subSubjectId: '',
    }));

    setSubSubjects([]);

    if (!subjectId) return;

    try {
      const res = await axios.get(
        `${baseUrl}api/admin/sub-subjects?subjectId=${subjectId}`,
        { headers },
      );
      setSubSubjects(res.data.data || []);
    } catch (err) {
      toast({ title: 'Sub-Subject load error', status: 'error' });
    }
  };

  // 🔹 Sub-Subject change
  const handleSubSubjectChange = (ssId) => {
    const suggestedOrder = ssId
      ? chapters.filter(
          (c) => (c.subSubjectId?._id || c.subSubjectId)?.toString() === ssId,
        ).length + 1
      : 0;

    setFormData({
      ...formData,
      subSubjectId: ssId,
      order: suggestedOrder,
    });
  };

  // ✅ Filter: Subject change — load sub-subjects for filter
  const handleFilterSubjectChange = async (subjectId) => {
    setFilterSubjectId(subjectId);
    setFilterSubSubjectId('');
    setFilterSubSubjects([]);
    if (!subjectId) return;
    try {
      const res = await axios.get(
        `${baseUrl}api/admin/sub-subjects?subjectId=${subjectId}`,
        { headers },
      );
      setFilterSubSubjects(res.data.data || []);
    } catch (err) {
      toast({ title: 'Sub-subject load error', status: 'error' });
    }
  };

  // ✅ Drag handlers — sirf filterSubSubjectId selected hone par kaam karte hain
  const handleDragStart = (e, index) => {
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', String(index)); // ← ye line required hai
    dragItem.current = index;
    hasDragged.current = false;
  };

  const handleDragEnter = (toIndex) => {
    const fromIndex = dragItem.current;
    if (fromIndex === null || fromIndex === toIndex) return;
    hasDragged.current = true;
    dragItem.current = toIndex;
    setDragOverIndex(toIndex);
    setOrderedList((prev) => {
      const next = [...prev];
      const [moved] = next.splice(fromIndex, 1);
      next.splice(toIndex, 0, moved);
      return next;
    });
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleDragEnd = () => {
    setDragOverIndex(null);
    if (hasDragged.current) setOrderChanged(true);
    dragItem.current = null;
    hasDragged.current = false;
  };

  // ✅ DB mein sub-subject-wise order persist karo
// ✅ BAAD MEIN — har chapter ki apni subSubjectId use karo
const handleSaveOrder = async () => {
  if (!filterSubjectId && !filterSubSubjectId) {
    return toast({
      title: 'Pehle Subject ya Sub-Subject filter select karein',
      status: 'warning',
    });
  }
  setSavingOrder(true);
  try {
    // Sub-subject ke hisaab se chapters group karo
    const grouped = {};
    orderedList.forEach((item, index) => {
      const ssId =
        item.subSubjectId?._id?.toString() ||
        item.subSubjectId?.toString();
      if (!grouped[ssId]) grouped[ssId] = [];
      grouped[ssId].push({ id: item._id, sortOrder: index + 1 });
    });

    // Har sub-subject ke liye alag API call
    await Promise.all(
      Object.entries(grouped).map(([ssId, items]) =>
        axios.post(
          `${baseUrl}api/admin/chapters/${ssId}/reorder`,
          { items },
          { headers },
        ),
      ),
    );

    toast({ title: 'Order saved!', status: 'success' });
    setOrderChanged(false);
    fetchData();
  } catch (err) {
    toast({ title: 'Failed to save order', status: 'error' });
  } finally {
    setSavingOrder(false);
  }
};

  // 🔹 CREATE CHAPTER
  const handleCreate = async () => {
    if (!formData.courseId || !formData.subjectId || !formData.subSubjectId) {
      return toast({
        title: 'Course, Subject and Sub-Subject required',
        status: 'warning',
      });
    }

    if (!formData.name || formData.name.trim().length < 3) {
      return toast({
        title: 'Chapter name must be at least 3 characters',
        status: 'warning',
      });
    }

    if (loading) return;

    setLoading(true);

    try {
      const payload = new FormData();

      Object.entries(formData).forEach(([key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
          payload.append(key, value);
        }
      });

      if (chapterImage) {
        payload.append('image', chapterImage);
      }

      await axios.post(`${baseUrl}api/admin/chapters`, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data',
        },
      });

      toast({ title: 'Chapter Created!', status: 'success' });

      setFormData({
        courseId: '',
        subjectId: '',
        subSubjectId: '',
        name: '',
        description: '',
        weightage: 0,
        isFreePreview: false,
      });

      setSubjects([]);
      setSubSubjects([]);
      setChapterImage(null);

      await fetchData();
    } catch (err) {
      toast({
        title: err.response?.data?.message || 'Create failed',
        status: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  // 🔹 UPDATE CHAPTER
  const handleUpdate = async () => {
    try {
      const payload = new FormData();

      payload.append(
        'subSubjectId',
        editData.subSubjectId?._id || editData.subSubjectId,
      );

      payload.append('name', editData.name);
      payload.append('description', editData.description || '');
      payload.append('weightage', editData.weightage);
      payload.append('order', editData.order ?? 0);
      payload.append('isFreePreview', editData.isFreePreview === true || editData.isFreePreview === 'true' ? 'true' : 'false');

      if (editData.newImage) {
        payload.append('image', editData.newImage);
      }

      await axios.patch(
        `${baseUrl}api/admin/chapters/${editData._id}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        },
      );

      toast({ title: 'Updated Successfully', status: 'success' });
      onClose();
      fetchData();
    } catch (err) {
      toast({
        title: err.response?.data?.message || 'Something went wrong',
        status: 'error',
      });
    }
  };

  // 🔹 DELETE CHAPTER
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure?')) {
      try {
        await axios.delete(`${baseUrl}api/admin/chapters/${id}`, { headers });
        toast({ title: 'Deleted', status: 'info' });
        fetchData();
      } catch (err) {
        toast({ title: 'Delete failed', status: 'error' });
      }
    }
  };

  // 🔹 filteredData — kept for reference, orderedList is used in table
  const filteredData = chapters
    .filter(
      (c) =>
        c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.subSubjectId?.name?.toLowerCase().includes(searchTerm.toLowerCase()),
    )
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));

  return (
    <Box pt={{ base: '130px', md: '80px', xl: '80px' }}>
      {/* ADD CHAPTER CARD — unchanged */}
      <Card mb="20px" p="20px">
        <Text color={textColor} fontSize="22px" fontWeight="700" mb="20px">
          Add New Chapter
        </Text>

        <Flex gap="15px" wrap="wrap">
          {/* COURSE */}
          <FormControl width={{ base: '100%', md: '20%' }}>
            <FormLabel fontSize="sm" fontWeight="700">
              Course
            </FormLabel>
            <Select
              placeholder="Select Course"
              value={formData.courseId}
              onChange={(e) => handleCourseChange(e.target.value)}
            >
              {courses.map((c) => (
                <option key={c._id} value={c._id}>
                  {c.name}
                </option>
              ))}
            </Select>
          </FormControl>

          {/* SUBJECT DROPDOWN */}
          <FormControl width={{ base: '100%', md: '20%' }}>
            <FormLabel fontSize="sm" fontWeight="700">
              Subject
            </FormLabel>
            <Select
              placeholder={loadingSubjects ? 'Loading...' : 'Select Subject'}
              value={formData.subjectId}
              onChange={(e) => handleSubjectChange(e.target.value)}
              isDisabled={!formData.courseId || loadingSubjects}
            >
              {subjects.map((s) => (
                <option key={s._id} value={s._id}>
                  {s.name}
                </option>
              ))}
            </Select>
          </FormControl>

          {/* SUB-SUBJECT */}
          <FormControl width={{ base: '100%', md: '20%' }}>
            <FormLabel fontSize="sm" fontWeight="700">
              Sub-Subject
            </FormLabel>
            <Select
              placeholder="Select Sub-Subject"
              value={formData.subSubjectId}
              onChange={(e) => handleSubSubjectChange(e.target.value)}
              isDisabled={!formData.subjectId}
            >
              {subSubjects.map((s) => (
                <option key={s._id} value={s._id}>
                  {s.name}
                </option>
              ))}
            </Select>
          </FormControl>

          {/* NAME */}
          <FormControl width={{ base: '100%', md: '20%' }}>
            <FormLabel fontSize="sm" fontWeight="700">
              Chapter Name
            </FormLabel>
            <Input
              value={formData.name}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  name: e.target.value,
                })
              }
              placeholder="Ex: Genetics"
            />
          </FormControl>

          {/* ORDER */}
          <FormControl width={{ base: '100%', md: '10%' }}>
            <FormLabel fontSize="sm" fontWeight="700">
              Order
            </FormLabel>
            <Input
              type="number"
              min={1}
              value={formData.order}
              onChange={(e) =>
                setFormData({ ...formData, order: Number(e.target.value) })
              }
              placeholder="Order"
            />
            {formData.subSubjectId && (
              <Text fontSize="xs" color="blue.400" mt="1">
                💡 Suggested:{' '}
                {chapters.filter(
                  (c) =>
                    (c.subSubjectId?._id || c.subSubjectId)?.toString() ===
                    formData.subSubjectId,
                ).length + 1}
              </Text>
            )}
          </FormControl>

          {/* DESCRIPTION */}
          <FormControl width="100%">
            <FormLabel fontSize="sm" fontWeight="700">
              Description
            </FormLabel>
            <ReactQuill
              theme="snow"
              value={formData.description}
              onChange={(value) =>
                setFormData({ ...formData, description: value })
              }
              modules={modules}
              formats={formats}
              style={{ background: 'white', minHeight: '150px' }}
            />
          </FormControl>

          {/* IMAGE */}
          <FormControl width={{ base: '100%', md: '20%' }}>
            <FormLabel fontSize="sm" fontWeight="700">
              Chapter Image
            </FormLabel>
            <Input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];

                if (!file) return;

                if (!file.type.startsWith('image/')) {
                  toast({
                    title: 'Only image files allowed',
                    status: 'warning',
                  });
                  return;
                }

                if (file.size > 2 * 1024 * 1024) {
                  toast({
                    title: 'Image must be less than 2MB',
                    status: 'warning',
                  });
                  return;
                }

                setChapterImage(file);
              }}
              pt="1"
            />
          </FormControl>

          <Button
            colorScheme="brand"
            mt="30px"
            onClick={handleCreate}
            isLoading={loading}
          >
            Save
          </Button>
        </Flex>
      </Card>

      {/* LIST TABLE */}
      <Card p="20px">
        {/* ✅ CHANGED: Title + filters + conditional Save Order button */}
        <Flex
          justify="space-between"
          mb="20px"
          align="center"
          flexWrap="wrap"
          gap="10px"
        >
          <Flex align="center" gap="3">
            <Text color={textColor} fontSize="18px" fontWeight="700">
              Chapters
            </Text>
            {orderChanged && (filterSubSubjectId || filterSubjectId) && (
              <Button
                size="sm"
                colorScheme="green"
                onClick={handleSaveOrder}
                isLoading={savingOrder}
                loadingText="Saving..."
              >
                💾 Save Order
              </Button>
            )}
          </Flex>

          <Flex gap="10px" align="center" flexWrap="auto">
            {/* Filter: Subject */}
            <Select
              value={filterSubjectId}
              onChange={(e) => handleFilterSubjectChange(e.target.value)}
              maxW="180px"
              size="sm"
              borderRadius="md"
            >
              {subjects.map((s) => (
                <option key={s._id} value={s._id}>
                  {s.name}
                </option>
              ))}
            </Select>

            {/* Filter: Sub-Subject */}
            <Select
              value={filterSubSubjectId}
              onChange={(e) => setFilterSubSubjectId(e.target.value)}
              maxW="180px"
              size="sm"
              borderRadius="md"
              isDisabled={!filterSubjectId}
            >
              {filterSubSubjects.map((s) => (
                <option key={s._id} value={s._id}>
                  {s.name}
                </option>
              ))}
            </Select>

            <InputGroup maxW="250px" size="sm">
              <InputLeftElement pointerEvents="none">
                <MdSearch color="gray.300" />
              </InputLeftElement>
              <Input
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                borderRadius="md"
              />
            </InputGroup>
          </Flex>
        </Flex>

        {/* ✅ Drag hint — sirf sub-subject filter active hone par dikhega */}
          {(filterSubSubjectId || filterSubjectId) && (
          <Text fontSize="xs" color="gray.400" mb="3">
            ☰ Rows ko drag karke reorder karein → "💾 Save Order" se
            permanently save karein
          </Text>
        )}

        <Box overflowX="auto">
          <Table variant="simple">
            <Thead bg={useColorModeValue('gray.50', 'navy.800')}>
              <Tr>
                <Th w="40px" px="2"></Th> {/* ✅ Drag handle column */}
                <Th>No.</Th>
                <Th>Image</Th>
                <Th>Name</Th>
                <Th>Sub-Subject</Th>
                <Th>Order</Th>
                <Th>Actions</Th>
              </Tr>
            </Thead>

            <Tbody>
              {/* ✅ CHANGED: filteredData → orderedList (drag support ke liye) */}
              {orderedList.map((item, i) => (
                <Tr
                  key={item._id}
                  draggable={!!(filterSubSubjectId || filterSubjectId)}
                  onDragStart={(e) => handleDragStart(e, i)}
                  onDragEnter={(e) => {
                    e.preventDefault();
                    handleDragEnter(i);
                  }}
                  onDragOver={(e) => e.preventDefault()}
                  onDragEnd={handleDragEnd}
                  bg={dragOverIndex === i ? dragOverBg : undefined}
                  transition="background 0.15s ease"
                  userSelect="none"
                 cursor={(filterSubSubjectId || filterSubjectId) ? 'grab' : 'default'}
                >
                  {/* ✅ Drag handle cell */}
                  <Td px="2">
                    {(filterSubSubjectId || filterSubjectId) && (
                      <Icon
                        as={MdDragIndicator}
                        color="gray.400"
                        boxSize="5"
                        cursor="grab"
                      />
                    )}
                  </Td>
                  <Td fontSize="sm">{i + 1}</Td>
                  <Td>
                    <Image
                      src={
                        item.image
                          ? item.image.startsWith('http')
                            ? item.image
                            : `${baseUrl.replace(/\/$/, '')}${item.image}`
                          : 'https://via.placeholder.com/50'
                      }
                      w="40px"
                      h="40px"
                      borderRadius="8px"
                      objectFit="cover"
                      fallbackSrc="https://via.placeholder.com/40"
                    />
                  </Td>
                  <Td fontWeight="700">{item.name}</Td>
                  <Td>
                    <Badge colorScheme="purple">
                      {item.subSubjectId?.name || 'N/A'}
                    </Badge>
                  </Td>
                  <Td>
                    <Badge colorScheme="orange" variant="subtle">
                      {item.order ?? '-'}
                    </Badge>
                  </Td>
                  <Td>
                    <IconButton
                      icon={<MdEdit />}
                      onClick={async () => {
                        setEditData(item);

                        const subjectId = item.subSubjectId?.subjectId?._id;

                        if (subjectId) {
                          try {
                            const res = await axios.get(
                              `${baseUrl}api/admin/sub-subjects?subjectId=${subjectId}`,
                              { headers },
                            );
                            setSubSubjects(res.data.data || []);
                          } catch (err) {
                            toast({
                              title: 'Failed to load sub-subjects',
                              status: 'error',
                            });
                          }
                        }

                        onOpen();
                      }}
                      mr="2"
                    />
                    <IconButton
                      icon={<MdDelete />}
                      colorScheme="red"
                      onClick={() => handleDelete(item._id)}
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </Card>

      {/* EDIT MODAL — unchanged */}
      {/* EDIT MODAL */}
<Modal isOpen={isOpen} onClose={onClose} size="lg">
  <ModalOverlay />
  <ModalContent pb="4">
    <ModalHeader>Edit Chapter</ModalHeader>
    <ModalCloseButton />
    <ModalBody>
      {editData && (
        <Flex direction="column" gap="4">

          {/* Subject */}
          <FormControl>
            <FormLabel fontWeight="600">Subject</FormLabel>
            <Select
              value={editData.subSubjectId?.subjectId?._id || ''}
              onChange={async (e) => {
                const subjectId = e.target.value;
                setEditData({ ...editData, subSubjectId: '' });
                try {
                  const res = await axios.get(
                    `${baseUrl}api/admin/sub-subjects?subjectId=${subjectId}`,
                    { headers },
                  );
                  setSubSubjects(res.data.data || []);
                } catch (err) {
                  toast({ title: 'Failed to load sub-subjects', status: 'error' });
                }
              }}
            >
              {subjects.map((s) => (
                <option key={s._id} value={s._id}>{s.name}</option>
              ))}
            </Select>
          </FormControl>

          {/* Sub-Subject */}
          <FormControl>
            <FormLabel fontWeight="600">Sub-Subject</FormLabel>
            <Select
              value={editData.subSubjectId?._id || editData.subSubjectId}
              onChange={(e) =>
                setEditData({ ...editData, subSubjectId: e.target.value })
              }
            >
              {subSubjects.map((ss) => (
                <option key={ss._id} value={ss._id}>{ss.name}</option>
              ))}
            </Select>
          </FormControl>

          {/* Chapter Name */}
          <FormControl>
            <FormLabel fontWeight="600">Chapter Name</FormLabel>
            <Input
              value={editData.name}
              onChange={(e) => setEditData({ ...editData, name: e.target.value })}
            />
          </FormControl>

          {/* Order */}
          <FormControl>
            <FormLabel fontWeight="600">Order</FormLabel>
            <Input
              type="number"
              min={1}
              value={editData.order ?? 0}
              onChange={(e) =>
                setEditData({ ...editData, order: Number(e.target.value) })
              }
            />
            <Text fontSize="xs" color="gray.400" mt="1">
              Total chapters in this sub-subject:{' '}
              {chapters.filter(
                (c) =>
                  (c.subSubjectId?._id || c.subSubjectId)?.toString() ===
                  (editData.subSubjectId?._id || editData.subSubjectId),
              ).length}
            </Text>
          </FormControl>

          {/* Description */}
          <FormControl>
            <FormLabel fontWeight="600">Description</FormLabel>
            <ReactQuill
              theme="snow"
              value={editData.description || ''}
              onChange={(val) => setEditData({ ...editData, description: val })}
              modules={modules}
              formats={formats}
              style={{ background: 'white' }}
            />
          </FormControl>

          {/* ✅ Current Image Preview */}
          <FormControl>
            <FormLabel fontWeight="600">Current Image</FormLabel>
            {editData.image ? (
              <Flex align="center" gap="3" mb="2">
                <Image
                  src={
                    editData.image.startsWith('http')
                      ? editData.image
                      : `${baseUrl.replace(/\/$/, '')}${editData.image}`
                  }
                  w="80px"
                  h="80px"
                  borderRadius="8px"
                  objectFit="cover"
                  fallbackSrc="https://via.placeholder.com/80"
                  border="1px solid"
                  borderColor="gray.200"
                />
                <Text fontSize="sm" color="gray.500">
                  ☝️ Current uploaded image
                </Text>
              </Flex>
            ) : (
              <Text fontSize="sm" color="gray.400" mb="2">
                ❌ No image uploaded
              </Text>
            )}

            {/* ✅ New image upload */}
            <FormLabel fontWeight="600" fontSize="sm" color="gray.600">
              Replace Image (optional)
            </FormLabel>
            <Input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (!file) return;
                if (!file.type.startsWith('image/')) {
                  toast({ title: 'Only image files allowed', status: 'warning' });
                  return;
                }
                if (file.size > 2 * 1024 * 1024) {
                  toast({ title: 'Image must be less than 2MB', status: 'warning' });
                  return;
                }
                setEditData({ ...editData, newImage: file });
              }}
              pt="1"
            />
            {/* ✅ New image selected preview */}
            {editData.newImage && (
              <Flex align="center" gap="2" mt="2">
                <Image
                  src={URL.createObjectURL(editData.newImage)}
                  w="60px"
                  h="60px"
                  borderRadius="6px"
                  objectFit="cover"
                  border="2px solid"
                  borderColor="green.300"
                />
                <Text fontSize="xs" color="green.500">
                  ✅ New image selected: {editData.newImage.name}
                </Text>
              </Flex>
            )}
          </FormControl>

        </Flex>
      )}
    </ModalBody>

    <ModalFooter>
      <Button colorScheme="brand" onClick={handleUpdate}>
        Update
      </Button>
    </ModalFooter>
  </ModalContent>
</Modal>
    </Box>
  );
}
